module.exports = __webpack_public_path__ + "static/media/Доклад на одитния комитет..d9af9e4b.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2021/Доклад на одитния комитет..pdf
// module id = 105
// module chunks = 0